// Shared z-index layer constants for the Data Sources panel stack.
//
// CHANNEL_BASE_LAYER_Z_INDEX (1300) matches the pinned zIndex used by the channel
// Dashboard/Settings Drawers and the icon-landing Drawer (ChannelDashboard.tsx,
// ChannelSettings.tsx, ThreadDetailPage.tsx) — those are intentionally pinned above
// MUI's default Drawer layer and are kept as literals there. The Data Sources panel
// must render above that base layer, so its own values are derived from it here
// instead of being independent magic numbers that could silently drift apart.
export const CHANNEL_BASE_LAYER_Z_INDEX = 1300;

/**
 * The icon-only landing view (ThreadDetailPage.tsx) is the one member of the base layer that's
 * always mounted with `open={true}` (kept mounted permanently to avoid a remount flash — see its
 * own comment). Because MUI's Modal stacking does not reliably re-order same-z-index Drawers by
 * JSX/mount order once one of them has been continuously open since initial render, an
 * always-open Drawer at the same z-index as Dashboard/Settings ends up covering them regardless
 * of which one opens later — reproduced directly against this project's MUI version. Pinning the
 * landing view just below the base layer removes the ambiguity without touching
 * Dashboard/Settings/Data Sources' own z-index values at all.
 */
export const CHANNEL_LANDING_VIEW_Z_INDEX = CHANNEL_BASE_LAYER_Z_INDEX - 10; // 1290

/** Backdrop behind the Data Sources panel. */
export const DATA_SOURCES_BACKDROP_Z_INDEX = CHANNEL_BASE_LAYER_Z_INDEX + 40; // 1340

/** The Data Sources slide-over panel itself. */
export const DATA_SOURCES_PANEL_Z_INDEX = CHANNEL_BASE_LAYER_Z_INDEX + 50; // 1350

/** Dialogs opened from within the Data Sources panel (must sit above the panel). */
export const DATA_SOURCES_DIALOG_Z_INDEX = CHANNEL_BASE_LAYER_Z_INDEX + 100; // 1400
